'use strict';
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$0024 from "./app.data.-User-Details$package$-User-First-Name$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails$package$UserFirstNameForm$() {
  this.aGa = null;
  this.aGl = null;
  this.aGd = null;
  this.aGe = false;
  this.aGj = null;
  this.aGk = false;
  this.aGb = null;
  this.aGc = false;
  this.aGh = null;
  this.aGi = false;
  this.aGf = null;
  this.aGg = false;
  $n_Lapp_data_UserDetails$package$UserFirstNameForm$ = this;
  this.aGa = $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$0024.$m_Lapp_data_UserDetails$package$UserFirstName$();
  this.aGl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$0024.$m_Lapp_data_UserDetails$package$UserFirstName$());
}
export { $c_Lapp_data_UserDetails$package$UserFirstNameForm$ as $c_Lapp_data_UserDetails$package$UserFirstNameForm$ };
$p = $c_Lapp_data_UserDetails$package$UserFirstNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserDetails$package$UserFirstNameForm$;
/** @constructor */
function $h_Lapp_data_UserDetails$package$UserFirstNameForm$() {
}
export { $h_Lapp_data_UserDetails$package$UserFirstNameForm$ as $h_Lapp_data_UserDetails$package$UserFirstNameForm$ };
$h_Lapp_data_UserDetails$package$UserFirstNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aGa;
});
$p.eO = (function() {
  return this.aGl;
});
$p.b9 = (function() {
  if ((!this.aGe)) {
    this.aGd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aGe = true;
  }
  return this.aGd;
});
$p.b3 = (function() {
  if ((!this.aGk)) {
    this.aGj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aGk = true;
  }
  return this.aGj;
});
$p.aG = (function() {
  if ((!this.aGc)) {
    this.aGb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aGc = true;
  }
  return this.aGb;
});
$p.az = (function() {
  if ((!this.aGi)) {
    this.aGh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aGi = true;
  }
  return this.aGh;
});
$p.aY = (function() {
  if ((!this.aGg)) {
    this.aGf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aGg = true;
  }
  return this.aGf;
});
var $d_Lapp_data_UserDetails$package$UserFirstNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails$package$UserFirstNameForm$, "app.data.UserDetails$package$UserFirstNameForm$", ({
  Fd: 1,
  N: 1
}));
export { $d_Lapp_data_UserDetails$package$UserFirstNameForm$ as $d_Lapp_data_UserDetails$package$UserFirstNameForm$ };
var $n_Lapp_data_UserDetails$package$UserFirstNameForm$;
function $m_Lapp_data_UserDetails$package$UserFirstNameForm$() {
  if ((!$n_Lapp_data_UserDetails$package$UserFirstNameForm$)) {
    $n_Lapp_data_UserDetails$package$UserFirstNameForm$ = new $c_Lapp_data_UserDetails$package$UserFirstNameForm$();
  }
  return $n_Lapp_data_UserDetails$package$UserFirstNameForm$;
}
export { $m_Lapp_data_UserDetails$package$UserFirstNameForm$ as $m_Lapp_data_UserDetails$package$UserFirstNameForm$ };
//# sourceMappingURL=app.data.-User-Details$package$-User-First-Name-Form$.js.map
